<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 27.9.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 97 27" style="enable-background:new 0 0 97 27;" xml:space="preserve">
	<style type="text/css">
	.st0{filter:url(#Adobe_OpacityMaskFilter);}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
	.st2{mask:url(#mask-2_00000057863271751574789740000015778107611560597942_);}
	.st3{fill-rule:evenodd;clip-rule:evenodd;}
	.st4{fill:#FF5F00;}
	.st5{fill:#EB001B;}
	.st6{fill:#F79E1B;}
</style>
	<g id="Page-1">
		<g id="Artboard" transform="translate(-1545.000000, -208.000000)">
			<g id="M_24px_dark" transform="translate(200.000000, 206.000000)">
				<g id="v0_mark_dark_M_24px" transform="translate(1345.000000, 2.000000)">
					<g id="UI-icon_x2F_SRC_x2F_dark" transform="translate(0.000000, 1.500000)">
						<g id="SRC_icon_black">
							<g id="path-1_00000067937529122706605920000004632933383824569277_">
							</g>
							<defs>
								<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0" y="0" width="38" height="24">
									<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
								</filter>
							</defs>
							<mask maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="24" id="mask-2_00000057863271751574789740000015778107611560597942_">
								<g class="st0">
									<polygon id="path-1_00000000903845320375220280000012961801126036731783_" class="st1" points="0,0 38,0 38,24 0,24
																	"/>
								</g>
							</mask>
							<path id="Fill-1" class="st2" d="M37.7,11.2L28.6,0.5C28.4,0.2,28,0,27.6,0c-0.6,0-1.1,0.5-1.1,1.1c0,0.3,0.1,0.6,0.4,0.8
							l8.2,10L27,21.8h-0.9h-2.6l7.7-9c0,0,0,0,0,0l0,0c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.5-0.3-0.8l0,0c0,0,0,0,0,0L22,0.6
							c0,0,0,0,0,0C21.8,0.2,21.4,0,21,0h-6.5c-0.6,0-1.1,0.5-1.1,1.1c0,0.2,0,0.4,0.1,0.5l8.6,10.4l-7.3,8.8c0,0-0.7,0.9-1.8,0.9
							H4.4c-1.2,0-2.2-0.9-2.2-2.2V4.4c0-1.1,1-2.2,2.2-2.2h5.4c0.6,0,1.1-0.4,1.1-1.1S10.5,0,9.8,0L4.3,0C1.7,0,0,2.2,0,4.4v15.3
							C0,22,2.1,24,4.3,24H13c0.4,0,0.8-0.1,1.2-0.2c0.1,0,0.1,0,0.2,0c1.2-0.4,1.9-1.2,2.1-1.4l8.2-9.6c0.4-0.4,0.4-1.1,0-1.6l0,0
							c0,0,0,0,0,0l-7.8-9h2.7h0.9l8.1,9.8l-8.5,10.4c0,0,0,0,0,0C20,22.6,20,22.7,20,22.9c0,0.6,0.5,1.1,1.1,1.1h6.5
							c0.4,0,0.7-0.2,0.9-0.5c0,0,0,0,0,0l9.2-10.6c0,0,0,0,0,0l0,0C38.1,12.3,38.1,11.7,37.7,11.2"/>
						</g>
					</g>
					<path id="Pipe" class="st3" d="M46.5,1.5L46.5,1.5C46.8,1.5,47,1.7,47,2v23c0,0.3-0.2,0.5-0.5,0.5l0,0c-0.3,0-0.5-0.2-0.5-0.5V2
					C46,1.7,46.2,1.5,46.5,1.5z"/>
					<g id="UI-Networks_x2F_Mastercard" transform="translate(55.000000, 0.500000)">
						<g id="mc_symbol">
							<rect id="Rectangle" x="14.9" y="2.9" class="st4" width="12.4" height="20.2"/>
							<path id="Path" class="st5" d="M16.1,13c0-3.9,1.8-7.7,4.9-10.1C15.8-1.2,8.2-0.6,3.6,4.3s-4.6,12.5,0,17.4s12.2,5.5,17.5,1.4
							C17.9,20.6,16.1,16.9,16.1,13z"/>
							<path id="Path_00000127759382735160381150000009023694632492297628_" class="st6" d="M42,13c0,4.9-2.8,9.4-7.3,11.5
							s-9.7,1.6-13.6-1.5C24.2,20.6,26,16.9,26,13s-1.8-7.7-4.9-10.1c3.9-3,9.2-3.6,13.6-1.5S42,8.1,42,13L42,13z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</svg>
